/**
 * "Στο ίδιο στυλ" carousel (sections/same-series-products.liquid).
 * Behaves like the Rebuy product carousels: a full page of cards per arrow
 * click, clickable page bars, and rewinding from the last page to the first.
 * Arrows and bars lock (hide) when every card already fits.
 */
if (!customElements.get('same-series-slider')) {
  customElements.define(
    'same-series-slider',
    class SameSeriesSlider extends HTMLElement {
      connectedCallback() {
        const mobile = parseInt(this.dataset.columnsMobile, 10);
        const tablet = parseInt(this.dataset.columnsTablet, 10);
        const desktop = parseInt(this.dataset.columnsDesktop, 10);

        this.carousel = new window.FoxTheme.Carousel(this.querySelector('.swiper'), {
          slidesPerView: mobile,
          slidesPerGroup: mobile,
          rewind: true,
          threshold: 2,
          navigation: {
            prevEl: this.querySelector('.same-series-products__arrow--prev'),
            nextEl: this.querySelector('.same-series-products__arrow--next'),
          },
          pagination: {
            el: this.querySelector('.same-series-products__pagination'),
            clickable: true,
            bulletClass: 'same-series-products__dot',
            bulletActiveClass: 'same-series-products__dot--active',
          },
          breakpoints: {
            768: { slidesPerView: tablet, slidesPerGroup: tablet },
            1024: { slidesPerView: desktop, slidesPerGroup: desktop },
          },
        });
        this.carousel.init();
      }

      disconnectedCallback() {
        if (this.carousel && this.carousel.slider) this.carousel.slider.destroy();
      }
    }
  );
}
